// extracted by css-extract-rspack-plugin
export default {"arrowButton":"CardsGalleryCards_arrowButton__41I8E"};